import { SectionRowViewModel } from './SectionRowViewModel';
import {
  SectionColumnConfigDataForStrainTypeColumn,
  SectionColumnConfigDataValue
} from '../../../../../../../../../models/enum/shared/section-column-config-data-value';
import { VariantBadge } from '../../../../../../../../../models/product/dto/variant-badge';
import { BadgeUtils } from '../../../../../../../../../utils/badge-utils';
import { FilterUtils } from '../../../../../../../../../utils/filter-utils';

export class SectionRowViewModelPlantlifeOneColumn extends SectionRowViewModel {
  override getReadableStrainType(
    strainTypeMode: SectionColumnConfigDataValue = SectionColumnConfigDataForStrainTypeColumn.StrainTypeSymbol
  ): string {
    return super.getReadableStrainType(strainTypeMode);
  }

  override getAllVariantBadges(): VariantBadge[] {
    const sectionType = this.section?.layoutType;
    const variantBadgeMap = this.section?.variantBadgeMap;
    const scopedVisibleVariants = this.getScopedVisibleVariants();
    const badges = BadgeUtils.getBadges(sectionType, 0, variantBadgeMap, scopedVisibleVariants);
    const limit = this.menu?.getAllowedBadgeCount();
    return badges?.filter(badge => !FilterUtils.keepPlantLifeTaggedBadges(badge))?.take(limit);
  }

  override getBadgesInlineWithName(): VariantBadge[] {
    const sectionType = this.section?.layoutType;
    const variantBadgeMap = this.section?.variantBadgeMap;
    const badges = BadgeUtils.getBadges(sectionType, 0, variantBadgeMap, this.getScopedVisibleVariants());
    return badges?.filter(FilterUtils.keepPlantLifeTaggedBadges);
  }

  override getBadgesForBadgeColumn(): VariantBadge[] {
    const sectionType = this.section?.layoutType;
    const variantBadgeMap = this.section?.variantBadgeMap;
    const badges = BadgeUtils.getBadges(sectionType, 0, variantBadgeMap, this.getScopedVisibleVariants());
    const limit = this.menu?.getAllowedBadgeCount();
    return badges?.filter(badge => !FilterUtils.keepPlantLifeTaggedBadges(badge))?.take(limit);
  }
}
